module.exports = __webpack_public_path__ + "assets/img/7_1080_big.20da2a9d.jpg";